<table *ngIf="!loading() && audits()" class="info stretched">
    <thead>
        <tr class="bordered-bottom sticky">
            <th>When</th>
            <th>Type</th>
            <th>Message</th>
            <th>Info</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let audit of audits(); let i = index" class="dashed-border-bottom">
            <td>{{ audit.when | date:'medium' }}</td>
            <td>{{ audit.eventName }}</td>
            <td>{{ audit.message }}</td>
            <ng-container [ngSwitch]="audit.eventName">
                <td *ngSwitchCase="'EVENTS_PER_HOUR'">
                    <div><span class="inline">Total expected events: </span> <span>{{audit.oldValue | number}}</span>
                    </div>
                    <div><span class="inline">Total actual events: </span> <span>{{audit.newValue | number}}</span>
                    </div>
                    <div><span class="inline">Average EPS: </span> <span>{{((+audit.newValue) / 3600) |
                            number : '1.0-0'}}</span>
                    </div>
                </td>
                <td *ngSwitchCase="'EVENTS_PER_DAY'">
                    <div><span class="inline">Total expected events: </span> <span>{{audit.oldValue | number}}</span>
                    </div>
                    <div><span class="inline">Total actual events: </span> <span>{{audit.newValue | number}}</span>
                    </div>
                    <div><span class="inline">Average EPS: </span> <span>{{((+audit.newValue) / 86400) |
                            number : '1.2-2'}}</span>
                    </div>
                </td>
                <td *ngSwitchDefault>
                    <div><span class="inline">Old Value: </span> <span>{{audit.oldValue}}</span></div>
                    <div><span class="inline">New Value: </span> <span>{{audit.newValue}}</span></div>
                </td>
            </ng-container>
        </tr>
    </tbody>
</table>
<div class="lastkey">
    <button *ngIf="lastKey()" class="btn" (click)="moreRecords($event)">
        <span>Load More Records</span>
    </button>
    <button *ngIf="!loading() && !lastKey()" class="btn">
        <span>No More Records</span>
    </button>
</div>

<div *ngIf="loading()">
    <div class="loader"></div>
</div>
